export default function initWordReveal() {
  const elements = document.querySelectorAll('[data-word-reveal]')
  if (!elements.length) return

  elements.forEach((el) => {
    wrapTextNodes(el, { i: 0 })
  })

  const io = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return
      entry.target.classList.add('is-visible')
      io.unobserve(entry.target)
    })
  }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' })

  elements.forEach((el) => io.observe(el))
}

function wrapTextNodes(node, counter) {
  Array.from(node.childNodes).forEach((child) => {
    if (child.nodeType === Node.TEXT_NODE) {
      const parts = child.textContent.split(/(\s+)/)
      const fragment = document.createDocumentFragment()
      parts.forEach((part) => {
        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part))
        } else if (part) {
          const span = document.createElement('span')
          span.className = 'wr-word'
          span.style.transitionDelay = `${counter.i++ * 40}ms`
          span.textContent = part
          fragment.appendChild(span)
        }
      })
      child.parentNode.replaceChild(fragment, child)
    } else if (child.nodeType === Node.ELEMENT_NODE) {
      wrapTextNodes(child, counter)
    }
  })
}
